/**
 * Global alert helper for the app.
 * All user-facing success/error messages (validation, API errors) should go through
 * this module so they use the same component (sonner Toaster) in the same way.
 */

import { toast } from 'sonner@2.0.3';

export function showError(message: string): void {
  toast.error(message);
}

export function showSuccess(message: string): void {
  toast.success(message);
}
